import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { GestionDonneesModule } from '../gestion-donnees/gestion-donnees.module';
import { FilterUserByProfilePipe } from 'src/app/shared/pipes/filterUsers/filter-user-by-profile/filter-user-by-profile.pipe';
import { ListUsersComponent } from './list-user/list-user.component';
import { UserModalAjoutFormComponent } from './modal/user-modal-ajout-form/user-modal-ajout-form.component';
import { UserFormComponent } from './user-form/user-form.component';
import { DetailUserComponent } from './detail-user/detail-user.component';
import { FilterUserByNamePipe } from 'src/app/shared/pipes/filter-user-by-name/filter-user-by-name.pipe';

@NgModule({
	declarations: [
		DetailUserComponent,
		UserFormComponent,
		ListUsersComponent,
		UserModalAjoutFormComponent
	],
	imports: [SharedModule, GestionDonneesModule],
	providers: [FilterUserByProfilePipe, FilterUserByNamePipe]
})
export class UsersModule {}
